
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airdrops/new",
      function () {
        return require("private-next-pages/airdrops/new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airdrops/new"])
      });
    }
  